/**
 * Default images used throughout the application
 * These are fallllllback images when events or profiles don't have images
 */

export const DEFAULT_EVENT_IMAGE = '/assets/images/event.png';
export const DEFAULT_PROFILE_IMAGE = '/assets/images/blank-profile.png';
